import React, { Component } from 'react'
import TextField from '@material-ui/core/TextField'
import PropTypes from 'prop-types'
import FieldLabelLink from './FieldLabelLink'

class CustomTextField extends Component {
  state = {}

  render() {
    const {
      value = '',
      onChange,
      onUpdate,
      settings = {},
      selectedLanguage,
      helperText,
      label,
      InputLabelProps,
      ...rest
    } = this.props
    const { error } = this.state

    const { multilang, linkTemplate, linkText, ...textFieldSettings } = settings
    const dir = multilang && selectedLanguage && selectedLanguage.rtl ? 'rtl' : undefined
    const resolvedInputLabelProps = linkTemplate
      ? {
          ...InputLabelProps,
          style: {
            ...(InputLabelProps && InputLabelProps.style),
            pointerEvents: 'auto',
          },
        }
      : InputLabelProps

    return (
      <TextField
        autocomplete={false}
        {...rest}
        {...textFieldSettings}
        dir={dir}
        value={value}
        error={error}
        label={
          <FieldLabelLink
            label={label}
            linkTemplate={linkTemplate}
            linkText={linkText}
            value={value}
          />
        }
        InputLabelProps={resolvedInputLabelProps}
        onFocus={this._onFocus}
        onBlur={this._onBlur}
        onChange={this._onChange}
        helperText={helperText}
      />
    )
  }

  _onChange = e => {
    const { target = {} } = e
    const { value, pattern, checkValidity } = target

    if (
      value !== '' &&
      pattern !== '' &&
      typeof checkValidity === 'function' &&
      !checkValidity.call(target)
    )
      return

    const { onUpdate } = this.props
    onUpdate && onUpdate(e.target.value)
  }

  _onFocus = e => {
    this.setState({ error: false })

    const { onFocus } = this.props
    onFocus && onFocus(e)
  }

  _onBlur = e => {
    try {
      const isValid = e.target.checkValidity()
      this.setState({ error: !isValid })
    } catch (err) {}

    const { onChange } = this.props
    onChange && onChange(e)
  }
}

CustomTextField.propTypes = {
  helperText: PropTypes.string,
}

export default CustomTextField
